(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_4e695f7"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mangoal-paper')) {
    customElements.define('mangoal-paper', class extends HTMLElement {
      connectedCallback() {
        this.copy = this.querySelector('.mh-paper__copy');
        this.button = this.querySelector('.mh-paper__expand');
        this.scrollHint = this.querySelector('.mh-paper__scroll');
        this.media = window.matchMedia('(max-width: 749px)');
        if (!this.copy || !this.button) return;
        this.expanded = false;
        this.refresh = () => {
          const mobile = this.media.matches;
          const mobileHeight = parseFloat(getComputedStyle(this).getPropertyValue('--mh-mobile-height')) || 300;
          const overflowing = this.copy.scrollHeight > mobileHeight + 2;
          this.classList.toggle('is-collapsible', mobile && overflowing);
          this.classList.toggle('is-expanded', this.expanded);
          this.button.hidden = !mobile || !overflowing;
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.button.querySelector('[data-expand]').hidden = this.expanded;
          this.button.querySelector('[data-collapse]').hidden = !this.expanded;
          this.button.querySelector('.mh-paper__plus').textContent = this.expanded ? '−' : '+';
          this.scrollHint.hidden = mobile || this.copy.scrollHeight <= this.copy.clientHeight + 2;
          if (mobile && !this.expanded && overflowing) {
            this.copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(el => {
              if (!this.savedTabs.has(el)) this.savedTabs.set(el, el.getAttribute('tabindex'));
              el.setAttribute('tabindex', '-1');
            });
          } else {
            this.savedTabs.forEach((value, el) => value === null ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', value));
            this.savedTabs.clear();
          }
          if (mobile) this.copy.removeAttribute('tabindex');
          else this.copy.setAttribute('tabindex', '0');
        };
        this.savedTabs = new Map();
        this.toggle = () => {
          const collapsing = this.expanded;
          this.expanded = !this.expanded;
          this.refresh();
          if (collapsing) this.button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        };
        this.button.addEventListener('click', this.toggle);
        this.media.addEventListener('change', this.refresh);
        this.classList.add('is-ready');
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.copy);
        this.observer.observe(this.querySelector('.mh-paper__prose'));
        this.refresh();
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggle);
        this.media?.removeEventListener('change', this.refresh);
        this.observer?.disconnect();
        this.savedTabs?.forEach((value, el) => value === null ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', value));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
